import { LoanCaseDTO } from "@smartx/mikro-vt-client-api"
import { ContractInvisibleStatusesList } from "../utils/constants"

export const isAccordionVisibleByStatus = (loancase: LoanCaseDTO) => {
  /* Only for contract accordion visibility for now */
  return !ContractInvisibleStatusesList.includes(loancase.loanCaseStatus.status)
}
